/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Fragment } from 'react';

import ErrorBoundaryWithTagging from '@coursera-web/common/components/ErrorBoundaryWithTagging';

import VisibilityTracking from 'bundles/page-config-common/components/shared/VisibilityTracking';
import PageConfigComponentMetadataProvider from 'bundles/page-config-common/providers/PageConfigComponentMetadataProvider';
import type { PageConfig_ComponentConfigFragment as PageConfigComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

type Props = {
  pageConfigComponents: Array<PageConfigComponent | null | undefined>;
  renderComponent: (
    pageConfigComponent: PageConfigComponent,
    pageConfigComponents: Array<PageConfigComponent | null | undefined>,
    index: number
  ) => JSX.Element | null;
};

const PageConfigComponentRendererWrapper = (props: Props) => {
  const { pageConfigComponents, renderComponent } = props;

  return (
    <Fragment>
      {pageConfigComponents.map((pageConfigComponent, index) => {
        if (!pageConfigComponent) {
          return null;
        }

        return (
          <PageConfigComponentMetadataProvider
            key={pageConfigComponent.id}
            id={pageConfigComponent.id}
            index={index}
            name={pageConfigComponent.__typename}
            recommender={{
              context: pageConfigComponent.rankingContext ?? undefined,
              hash: pageConfigComponent.recommenderConfigurationHash ?? '',
            }}
          >
            <VisibilityTracking pageConfigComponent={pageConfigComponent} index={index}>
              <ErrorBoundaryWithTagging componentName={pageConfigComponent.__typename}>
                {renderComponent(pageConfigComponent, pageConfigComponents, index)}
              </ErrorBoundaryWithTagging>
            </VisibilityTracking>
          </PageConfigComponentMetadataProvider>
        );
      })}
    </Fragment>
  );
};

export default PageConfigComponentRendererWrapper;
